import stringsIT from './strings-it.json';

const strings = {
  it: stringsIT,
};

export default strings;
